import { render, staticRenderFns } from "./GestionUsers.vue?vue&type=template&id=2776ed28"
import script from "./GestionUsers.vue?vue&type=script&lang=js"
export * from "./GestionUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports